interface ExitViewProps {
    isError?: boolean;
}

export default function ExitView({ isError = false }: ExitViewProps) {
    return (
        <>
            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(16px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                @keyframes scaleIn {
                    from { opacity: 0; transform: scale(0.6); }
                    to   { opacity: 1; transform: scale(1); }
                }
                .exit-card {
                    animation: fadeIn 0.5s ease-out forwards;
                }
                .exit-icon {
                    animation: scaleIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) 0.15s both;
                }
            `}</style>

            <div style={{
                width: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#F9FAFB',
                padding: '24px',
                boxSizing: 'border-box',
            }}>
                <div
                    className="exit-card"
                    style={{
                        backgroundColor: 'white',
                        borderRadius: '20px',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
                        padding: '48px 40px',
                        maxWidth: '400px',
                        width: '100%',
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '0',
                    }}
                >
                    {/* Icon */}
                    <div
                        className="exit-icon"
                        style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            backgroundColor: isError ? '#FEF2F2' : '#ECFDF5',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '28px',
                            fontSize: '40px',
                        }}
                    >
                        {isError ? '⚠️' : '✅'}
                    </div>

                    {/* Heading */}
                    <h1 style={{
                        margin: '0 0 12px 0',
                        fontSize: '24px',
                        fontWeight: '700',
                        color: '#111827',
                        lineHeight: '1.3',
                    }}>
                        {isError ? 'Verification Incomplete' : 'Verification Complete!'}
                    </h1>

                    {/* Body text */}
                    <p style={{
                        margin: '0 0 32px 0',
                        fontSize: '16px',
                        lineHeight: '1.6',
                        color: '#6B7280',
                    }}>
                        {isError
                            ? 'Something went wrong during verification. Please return to your computer and try again.'
                            : 'You have successfully completed the identity check. You can now return to your computer to continue.'
                        }
                    </p>

                    {/* Instruction pill */}
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        backgroundColor: '#F3F4F6',
                        borderRadius: '12px',
                        padding: '14px 20px',
                        width: '100%',
                        boxSizing: 'border-box',
                    }}>
                        <span style={{ fontSize: '22px' }}>💻</span>
                        <span style={{
                            fontSize: '14px',
                            fontWeight: '500',
                            color: '#374151',
                            textAlign: 'left',
                            lineHeight: '1.4',
                        }}>
                            Continue on your main device
                        </span>
                    </div>

                    {/* Dismissal hint */}
                    <p style={{
                        marginTop: '24px',
                        marginBottom: '0',
                        fontSize: '13px',
                        color: '#9CA3AF',
                    }}>
                        This page can be safely closed.
                    </p>
                </div>
            </div>
        </>
    );
}
